import React from 'react';
import {
  AppBar,
  Toolbar,
  Container,
  Typography,
  Box,
  Button,
  useTheme,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SearchIcon from '@mui/icons-material/Search';
import DescriptionIcon from '@mui/icons-material/Description';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const menuItems = [
    { label: 'Início', path: '/', icon: <AccountBalanceIcon /> },
    { label: 'Consultar Valores', path: '/consulta', icon: <SearchIcon /> },
    { label: 'Documentos', path: '/documentos', icon: <DescriptionIcon /> },
  ];

  // Verificar se é admin
  const isAdmin = localStorage.getItem('admin_token');

  return (
    <AppBar 
      position="static" 
      elevation={0}
      sx={{ 
        backgroundColor: 'white',
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        py: 1,
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
          {/* Logo e Nome */}
          <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => navigate('/')}>
            <Box
              sx={{
                width: 60,
                height: 60,
                backgroundColor: theme.palette.primary.main,
                borderRadius: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mr: 2,
              }}
            >
              <AccountBalanceIcon sx={{ color: 'white', fontSize: 32 }} />
            </Box>
            <Box>
              <Typography 
                variant="h5" 
                color="primary.main"
                fontWeight="bold"
                sx={{ lineHeight: 1 }}
              >
                SINTET
              </Typography>
              <Typography 
                variant="subtitle2" 
                color="secondary.main"
                sx={{ lineHeight: 1, mt: 0.5 }}
              >
                Consulta de Valores Devidos (Ação do 1/3 de Férias)
              </Typography>
            </Box>
          </Box>

          {/* Menu */}
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            {menuItems.map((item) => (
              <Button
                key={item.path}
                startIcon={item.icon}
                onClick={() => navigate(item.path)}
                sx={{
                  color: location.pathname.startsWith(item.path) ? theme.palette.primary.main : theme.palette.text.secondary,
                  fontWeight: location.pathname.startsWith(item.path) ? 600 : 400,
                  borderBottom: location.pathname.startsWith(item.path) ? `2px solid ${theme.palette.primary.main}` : 'none',
                  borderRadius: 0,
                  '&:hover': {
                    backgroundColor: 'transparent',
                    color: theme.palette.primary.main,
                  },
                }}
              >
                {item.label}
              </Button>
            ))}
            
            {/* Botão Admin */}
            <Button
              startIcon={<AdminPanelSettingsIcon />}
              onClick={() => isAdmin ? navigate('/admin/documentos') : navigate('/admin/login')}
              sx={{
                color: location.pathname.startsWith('/admin') ? theme.palette.secondary.main : theme.palette.text.secondary,
                fontWeight: location.pathname.startsWith('/admin') ? 600 : 400,
                borderBottom: location.pathname.startsWith('/admin') ? `2px solid ${theme.palette.secondary.main}` : 'none',
                borderRadius: 0,
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: theme.palette.secondary.main,
                },
              }}
            >
              {isAdmin ? 'Admin' : 'Login Admin'}
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;